import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
})
export default class LineChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>;
  @Prop({ default: () => ([]) }) readonly dataValue: any;
  @Prop({ default: null }) index: number
  color = ['#37A2DA','#32C5E9','#67E0E3','#9FE6B8','#FFDB5C','#ff9f7f','#fb7293','#E062AE','#E690D1','#e7bcf3','#9d96f5','#8378EA','#96BFFF']
  standardEfficiency = null

  mounted(){
    this.init()
  }
  seriesDataItem(obj){
    const data = []
    Object.keys(obj).sort().forEach(function(key){
      const value = obj[key] * 100
      data.push(value.toFixed(2))
    });
    return data
  }

  init() {
    const xAxisData = []
    const seriesData = []
    const legendData = []
    this.columns.forEach(item => {
      xAxisData.push(item.title)
    });
    this.dataValue.forEach(res =>{
      this.standardEfficiency = res.standardEfficiency
      const seriesValue = {
        name: res.workStationName,
        type: 'line',
        smooth: true,
        data: this.seriesDataItem(res.data),
        markLine: this.standardEfficiency ? {
          silent: true,
          lineStyle: {
            normal: {
              color: 'red'                   // 这儿设置安全基线颜色
            }
          },
          data: [{
            yAxis: this.standardEfficiency
          }],
          label: {
            normal: {
              formatter: '标准\n效率'           // 这儿设置安全基线
            }
          },
        }: null,
      }
      legendData.push(res.workStationName)
      seriesData.push(seriesValue)
    })
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart as any
    );
    // 指定图表的配置项和数据
    var option = {
      title: {
        show: false
      },
      tooltip: {
        trigger: 'axis'
      },
      color: this.color,
      legend: {
        show: (this.dataValue.length > 1),
        data: legendData,
        selectedMode: false
      },
      grid: {
        top: '30',
        left: '20',
        right: '60',
        bottom: '2%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          show: true,
          interval: 0,
          rotate: -35,
          margin: 19,
          formatter: (val) => {
            var strs = val.split(''); //字符串数组
            var str = ''
            for(var i = 0, s; s = strs[i++];) { //遍历字符串数组
            str += s;
            if(!(i % 8)) str += '\n'; //按需要求余
            }
            return str
          },
        },
        axisLine: {onZero: true},
        data: xAxisData
      },
      yAxis: {
        type: 'value',
        boundaryGap: true,
        axisLine: {
            show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
              type: 'dashed'
          }
        },
        axisLabel:{
          formatter: value =>{
            return value + '%'
          }
        }
      },
      visualMap: this.standardEfficiency ? {
        show: false,
        pieces: [
          {
            gt: 0,
            lte: this.standardEfficiency,          //这儿设置基线上下颜色区分 基线下面为红色
            color: '#e91642'
          }, {
            gt: this.standardEfficiency,          //这儿设置基线上下颜色区分 基线上面为绿色
            color: '#37A2DA'
          }]
      } : null,
      series: seriesData
  };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }

  render() {
    return (
      <div ref="myChart" style={{width: (85 * (this.columns.length > 9 ? this.columns.length : 10 )) + 'px', height: '300px'}}></div>
    )
  }
}
